"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPatio = function SvgPatio(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.043 13.065V5.99",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.535 17.5A3.5 3.5 0 0 0 7 20.5h10a3.5 3.5 0 0 0 3.465-3H3.535zm3.015-4a2.5 2.5 0 0 0 2.45 2h6a2.5 2.5 0 0 0 2.45-2H6.55z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.038 13.51h13.921M2.01 17.523h19.98",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    d: "M10.5 15.5h3v2h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7c0-1.657-1.12-3-2.5-3S7 5.343 7 7m5 6c0-2.761-1.79-5-4-5s-4 2.239-4 5m16 0c0-2.761-1.79-5-4-5s-4 2.239-4 5m5-6c0-1.657-1.12-3-2.5-3S12 5.343 12 7",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPatio);
var _default = exports["default"] = Memo;